import './utils/check-browser';

import '@/styles';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import { resolveEnvironmentVariables } from '@inn/utils';
import dayjs from 'dayjs';
import { router } from './router';
import 'dayjs/locale/zh-cn';

import XomApp from './app.vue';

const { IS_DEV, IS_TEST } = resolveEnvironmentVariables();

dayjs.locale('zh-cn');

const app = createApp(XomApp);
const pinia = createPinia();
const persisted = createPersistedState({
  storage: localStorage,
  // todo: serializer and encodes
  debug: IS_DEV || IS_TEST,
});

pinia.use(persisted);
app.use(pinia).use(router).mount('#xom-apps-main');
app.config.performance = true;
